
/* Strand Luxe — minimal JS */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {

    /* ── Cart drawer ── */
    var cartDrawer = document.getElementById('cart-drawer');
    var cartOverlay = document.getElementById('cart-drawer-overlay');
    var cartClose = document.getElementById('cart-drawer-close');
    var cartItemsHost = document.getElementById('cart-drawer-items');
    var cartSubtotalHost = document.getElementById('cart-drawer-subtotal');

    function formatMoney(cents, currency) {
      var amount = (Number(cents || 0) / 100);
      var code = currency || 'INR';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount);
      } catch (e) {
        return '\u20b9' + amount.toFixed(2);
      }
    }

    function closeCartDrawer() {
      if (!cartDrawer || !cartOverlay) return;
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      cartOverlay.classList.remove('is-open');
      cartOverlay.hidden = true;
      document.body.style.overflow = '';
    }

    function renderCartDrawer(cart) {
      if (!cartItemsHost || !cartSubtotalHost) return;
      if (!cart || !cart.items || cart.items.length === 0) {
        cartItemsHost.innerHTML = '<div class="cart-drawer-empty">Your cart is empty.</div>';
        cartSubtotalHost.textContent = formatMoney(0, cart && cart.currency);
        return;
      }

      var html = cart.items.map(function(item) {
        var img = item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '">' : '<div style="width:70px;height:70px;background:var(--surface-2)"></div>';
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="cart-drawer-item-meta">' + item.variant_title + '</div>' : '';
        var qty = '' +
          '<div class="cart-drawer-qty">' +
            '<button type="button" class="js-cart-qty" data-key="' + item.key + '" data-next="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" class="js-cart-qty" data-key="' + item.key + '" data-next="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>';
        return '' +
          '<div class="cart-drawer-item">' +
            '<a href="' + item.url + '">' + img + '</a>' +
            '<div>' +
              '<a class="cart-drawer-item-title" href="' + item.url + '">' + item.product_title + '</a>' +
              variant + qty +
            '</div>' +
            '<div class="cart-drawer-item-price">' + formatMoney(item.final_line_price, cart.currency) + '</div>' +
          '</div>';
      }).join('');

      cartItemsHost.innerHTML = html;
      cartSubtotalHost.textContent = formatMoney(cart.total_price, cart.currency);
    }

    function updateCartCountFromData(cart) {
      var badge = document.querySelector('.cart-count');
      if (cart.item_count > 0) {
        if (badge) {
          badge.textContent = cart.item_count;
        } else {
          var cartLink = document.querySelector('.header-icon[aria-label="Cart"]');
          if (cartLink) {
            var span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = cart.item_count;
            cartLink.appendChild(span);
          }
        }
      } else if (badge) {
        badge.remove();
      }
    }

    function openCartDrawer() {
      if (!cartDrawer || !cartOverlay) return;
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          renderCartDrawer(cart);
          cartOverlay.hidden = false;
          cartOverlay.classList.add('is-open');
          cartDrawer.classList.add('is-open');
          cartDrawer.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        })
        .catch(function() {
          window.location.href = '/cart';
        });
    }

    if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeCartDrawer();
    });

    /* ── Mobile menu ── */
    var hamburger = document.querySelector('.hamburger');
    var mobileMenu = document.querySelector('.mobile-menu');
    if (hamburger && mobileMenu) {
      hamburger.addEventListener('click', function() {
        var open = mobileMenu.classList.toggle('is-open');
        hamburger.classList.toggle('is-open', open);
        hamburger.setAttribute('aria-expanded', open);
      });
    }

    /* ── Product image gallery ── */
    var thumbs = document.querySelectorAll('.product-thumb');
    var mainImg = document.querySelector('.product-main-image img');
    if (thumbs.length && mainImg) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var src = this.querySelector('img').getAttribute('data-full') ||
                    this.querySelector('img').src;
          mainImg.src = src;
          thumbs.forEach(function(t) { t.classList.remove('active'); });
          this.classList.add('active');
        });
      });
    }

    /* ── AJAX Add to Cart (no page navigation) ── */
    var atcForm = document.querySelector('#product-form');
    if (atcForm) {
      atcForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = atcForm.querySelector('[name="add"]');
        if (!btn || btn.disabled) return;
        var orig = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding\u2026';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(atcForm)
        })
        .then(function(r) {
          if (!r.ok) return r.json().then(function(d){ throw d; });
          return r.json();
        })
        .then(function(item) {
          btn.textContent = 'Added \u2713';
          btn.classList.add('product-atc--added');
          showToast('\u2713 ' + item.title + ' added to cart');
          updateCartCount();
          openCartDrawer();
          setTimeout(function() {
            btn.textContent = orig;
            btn.disabled = false;
            btn.classList.remove('product-atc--added');
          }, 2200);
        })
        .catch(function(err) {
          var msg = (err && err.description) ? err.description : 'Could not add to cart';
          showToast('\u26a0 ' + msg, true);
          btn.textContent = orig;
          btn.disabled = false;
        });
      });
    }

    /* ── Update cart count badge after AJAX add ── */
    function updateCartCount() {
      fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart) {
          updateCartCountFromData(cart);
        });
    }

    /* ── Cart drawer quantity controls ── */
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.js-cart-qty');
      if (!btn) return;
      e.preventDefault();
      var key = btn.getAttribute('data-key');
      var nextQty = parseInt(btn.getAttribute('data-next'), 10);
      if (!key || Number.isNaN(nextQty)) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: key, quantity: nextQty })
      })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(d){ throw d; });
        return r.json();
      })
      .then(function(cart) {
        renderCartDrawer(cart);
        updateCartCountFromData(cart);
      })
      .catch(function() {
        showToast('Could not update cart quantity', true);
      });
    });

    /* ── Quick Add from product cards ── */
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.js-quick-add');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(d){ throw d; });
        return r.json();
      })
      .then(function(item) {
        btn.textContent = 'Added \u2713';
        updateCartCount();
        openCartDrawer();
        showToast('\u2713 ' + item.title + ' added to cart');
        setTimeout(function() {
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function(err) {
        var msg = (err && err.description) ? err.description : 'Could not add to cart';
        showToast('\u26a0 ' + msg, true);
        btn.textContent = original;
        btn.disabled = false;
      });
    });

    /* ── Open side cart instead of cart page for header cart icon ── */
    var cartIcon = document.querySelector('.header-icon[aria-label="Cart"]');
    if (cartIcon) {
      cartIcon.addEventListener('click', function(e) {
        e.preventDefault();
        openCartDrawer();
      });
    }

    /* ── Generic add-to-cart forms: keep user on page and open drawer ── */
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (form.id === 'product-form') return;

      e.preventDefault();
      var submitBtn = form.querySelector('[name="add"], button[type="submit"], input[type="submit"]');
      var oldText = submitBtn ? (submitBtn.textContent || submitBtn.value || '') : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        if (submitBtn.tagName === 'INPUT') submitBtn.value = 'Adding...';
        else submitBtn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(d){ throw d; });
        return r.json();
      })
      .then(function(item) {
        updateCartCount();
        openCartDrawer();
        showToast('\u2713 ' + item.title + ' added to cart');
      })
      .catch(function(err) {
        var msg = (err && err.description) ? err.description : 'Could not add to cart';
        showToast('\u26a0 ' + msg, true);
      })
      .finally(function() {
        if (!submitBtn) return;
        submitBtn.disabled = false;
        if (submitBtn.tagName === 'INPUT') submitBtn.value = oldText || 'Add to cart';
        else submitBtn.textContent = oldText || 'Add to cart';
      });
    }, true);

    /* ── Toast notification ── */
    function showToast(msg, isError) {
      var toast = document.getElementById('strand-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.id = 'strand-toast';
        toast.className = 'strand-toast';
        document.body.appendChild(toast);
      }
      toast.textContent = msg;
      toast.style.background = isError ? 'var(--danger, #c0392b)' : '';
      toast.classList.add('strand-toast--visible');
      clearTimeout(toast._t);
      toast._t = setTimeout(function() { toast.classList.remove('strand-toast--visible'); }, 3200);
    }

    /* ── Sticky header shrink ── */
    var header = document.querySelector('.site-header');
    if (header) {
      window.addEventListener('scroll', function() {
        header.style.boxShadow = window.scrollY > 40
          ? '0 2px 20px rgba(0,0,0,.5)'
          : 'none';
      }, { passive: true });
    }

    /* ── Newsletter form ── */
    var nlForm = document.querySelector('.newsletter-form-js');
    if (nlForm) {
      nlForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var email = nlForm.querySelector('input[type="email"]').value;
        if (!email) return;
        var btn = nlForm.querySelector('.newsletter-btn');
        btn.textContent = 'Thank you!';
        btn.disabled = true;
      });
    }

    /* ── Mega-menu & dropdown nav ── */
    var megaItems = document.querySelectorAll('.nav-mega, .nav-drop');
    megaItems.forEach(function(item) {
      var panelId = item.dataset.panel;
      var panel   = panelId ? document.getElementById(panelId)
                            : item.querySelector('.drop-panel');
      if (!panel) return;
      var trigger = item.querySelector('.nav-chevron');
      var timer;

      function openPanel() {
        clearTimeout(timer);
        // Close any other open panels first
        megaItems.forEach(function(other) {
          if (other === item) return;
          var op = other.dataset.panel ? document.getElementById(other.dataset.panel)
                                       : other.querySelector('.drop-panel');
          if (op) op.classList.remove('is-open');
          other.classList.remove('is-open');
          var ot = other.querySelector('.nav-chevron');
          if (ot) ot.setAttribute('aria-expanded', 'false');
        });
        panel.classList.add('is-open');
        item.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        if (panel.hasAttribute('aria-hidden')) panel.setAttribute('aria-hidden', 'false');
      }

      function closePanel() {
        timer = setTimeout(function() {
          panel.classList.remove('is-open');
          item.classList.remove('is-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (panel.hasAttribute('aria-hidden')) panel.setAttribute('aria-hidden', 'true');
        }, 140);
      }

      item.addEventListener('mouseenter', openPanel);
      item.addEventListener('mouseleave', closePanel);
      panel.addEventListener('mouseenter', function() { clearTimeout(timer); });
      panel.addEventListener('mouseleave', closePanel);

      // Click: toggle the panel instead of following the link (panel already
      // opens on hover for mouse users; this stops the click from navigating
      // away before the panel can be used, and lets touch/keyboard users open it).
      if (trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          if (item.classList.contains('is-open')) {
            closePanel();
          } else {
            openPanel();
          }
        });
        trigger.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPanel(); }
          if (e.key === 'Escape') closePanel();
        });
      }
    });

    // Desktop category types open on hover, so following a category link is
    // never required just to see its children. Mobile keeps the native
    // <details> tap behaviour.
    var megaCategoryItems = document.querySelectorAll('.mega-category-item');
    megaCategoryItems.forEach(function(item) {
      var disclosure = item.querySelector('.mega-category-disclosure');
      if (!disclosure) return;
      item.addEventListener('mouseenter', function() {
        if (window.matchMedia('(min-width: 769px)').matches) disclosure.open = true;
      });
      item.addEventListener('mouseleave', function() {
        if (window.matchMedia('(min-width: 769px)').matches && !item.matches(':focus-within')) {
          disclosure.open = false;
        }
      });
    });

    // Close all on outside click
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.nav-mega, .nav-drop')) {
        megaItems.forEach(function(item) {
          var panelId = item.dataset.panel;
          var p = panelId ? document.getElementById(panelId)
                          : item.querySelector('.drop-panel');
          if (p) { p.classList.remove('is-open'); if (p.hasAttribute('aria-hidden')) p.setAttribute('aria-hidden','true'); }
          item.classList.remove('is-open');
          var t = item.querySelector('.nav-chevron');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Escape key closes all
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      megaItems.forEach(function(item) {
        var panelId = item.dataset.panel;
        var p = panelId ? document.getElementById(panelId) : item.querySelector('.drop-panel');
        if (p) { p.classList.remove('is-open'); if (p.hasAttribute('aria-hidden')) p.setAttribute('aria-hidden','true'); }
        item.classList.remove('is-open');
      });
    });

    /* ── Collection filter panel toggle ── */
    var cfBtn   = document.getElementById('cf-filter-btn');
    var cfPanel = document.getElementById('cf-panel');
    if (cfBtn && cfPanel) {
      cfBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = !cfPanel.hidden;
        cfPanel.hidden = isOpen;
        cfBtn.setAttribute('aria-expanded', !isOpen);
      });
      document.addEventListener('click', function(e) {
        if (!cfPanel.hidden && !cfPanel.contains(e.target) && e.target !== cfBtn && !cfBtn.contains(e.target)) {
          cfPanel.hidden = true;
          cfBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* ── Filter group accordion ── */
    var cfGroupBtns = document.querySelectorAll('.cf-group-title');
    cfGroupBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var body = btn.nextElementSibling;
        if (!body) return;
        var collapsed = body.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded', !collapsed);
      });
    });

    /* ── Sort select: preserve active filters in URL ── */
    var cfSort = document.getElementById('cf-sort-select');
    if (cfSort) {
      cfSort.addEventListener('change', function() {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', cfSort.value);
        params.delete('page');
        window.location.search = params.toString();
      });
    }

    /* ── Mobile accordion for catalog section ── */
    var accordionBtns = document.querySelectorAll('.mobile-accordion-btn');
    accordionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var panel = btn.nextElementSibling;
        if (!panel) return;
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open);
      });
    });

  });
})();
